module.exports = __webpack_public_path__ + "img/logo_completo.feda4f34.png";